import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GeneralDialogParams } from '../../models/error-notification-params.model';

@Component({
    selector: 'error-notification-dialog',
    templateUrl: './error-notification-dialog.component.html',
    styleUrls: ['./error-notification-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ErrorNotificationDialogComponent {
    title: string;
    message: string;

    constructor(@Inject(MAT_DIALOG_DATA) data: GeneralDialogParams) {
        if (data) {
            this.title = data.title;
            this.message = data.message;
        }
    }
}
